// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"G_TheComp__bFSXQ"};